export const SOCIAL = [
	{
		id: 1,
		name: 'Twitter',
		url: 'https://x.com/RNDM_IO',
		icon: '/twitter.png',
	},
	{
		id: 2,
		name: 'Discord',
		url: 'http://discord.gg/rndmio',
		icon: '/discord.png',
	},
];
